import { useSetting } from "@faire/marketplace-lib/settings/__internal__/useSetting";
import { R2B_REQUEST_TO_SHOP_EXPERIMENT_251002 } from "@faire/web-api--source/indigofair/settings/R2B_REQUEST_TO_SHOP_EXPERIMENT_251002";

export const useSettingRequestToShop = (): boolean =>
  useSetting(R2B_REQUEST_TO_SHOP_EXPERIMENT_251002, false);
